//export const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:3001";
export const BASE_URL = "https://api.owded.com";
